// core
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import nsToken from '@netsapiens/netsapiens-js/dist/token';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Apps from '@material-ui/icons/Apps';
import styles from '../styles.module.css';
import * as actions from '../../../../state';

function AppMenu() {
  const decodedToken = nsToken.getDecoded();
  const supervisorOrManger = decodedToken
    && (decodedToken.user_scope === 'Call Center Supervisor'
      || decodedToken.user_scope === 'Office Manager');

  const portalTitle = useSelector((state) => actions.selectConfig(state, 'PORTAL_TITLE_USER') || 'Portal');
  const attendantEnabled = useSelector((state) => actions.selectConfig(state, 'PORTAL_ATTENDANT_CONSOLE') === 'yes');
  // eslint-disable-next-line max-len
  const attendantTitle = useSelector((state) => actions.selectConfig(state, 'PORTAL_ATTENDANT_CONSOLE_NAME') || 'Attendant Console');
  const webPhoneEnabled = useSelector((state) => actions.selectConfig(state, 'PORTAL_ALLOW_WEB_PHONE') === 'yes');
  // eslint-disable-next-line max-len
  const webPhoneTitle = useSelector((state) => actions.selectConfig(state, 'PORTAL_WEB_PHONE_NAME') || 'SNAPmobile Web');
  
  let videoTitle = useSelector((state) => actions.selectConfig(state, 'PORTAL_VIDEO_NAME') || 'SNAP.HD');
  let videoEnabled = useSelector((state) => actions.selectConfig(state, 'PORTAL_VIDEO') === 'yes');
  const premiumVideoConfigured = useSelector((state) => actions.selectConfig(state, 'premiumVideoConfigured') || false);
  // eslint-disable-next-line max-len
  const premiumVideoName = useSelector((state) => actions.selectConfig(state, 'PORTAL_PREMIUM_VIDEO_NAME') || 'Premium Video');
  const premiumVideoUrl = useSelector((state) => actions.selectConfig(state, 'premiumVideoURL') || '/video');

  let videoPath = '/video';
  if (premiumVideoConfigured) {
    videoEnabled = true;
    videoTitle = premiumVideoName;
    videoPath = premiumVideoUrl;
  }
  
  // eslint-disable-next-line max-len
  const analyticsEnabled = useSelector((state) => actions.selectConfig(state, 'PORTAL_ANALYTICS_FEATURE_ENABLED') === 'yes' && supervisorOrManger);
  // eslint-disable-next-line max-len
  const analyticsTitle = useSelector((state) => actions.selectConfig(state, 'PORTAL_ANALYTICS_FEATURE_NAME') || 'SNAPanalytics');

  const [appsMenuAnchorEl, setAppsMenuAnchorEl] = useState(null);

  const handleAppsMenuClose = () => {
    setAppsMenuAnchorEl(null);
  };

  const openAppsMenuMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAppsMenuAnchorEl(e.currentTarget);
  };

  return (
    <>
      <IconButton
        id="appMenuBtn"
        tabIndex="0"
        onClick={openAppsMenuMenu}
        onKeyPress={openAppsMenuMenu}
        className={`animated slow fadeIn ${styles.appMenuBtn}`}
      >
        <Apps />
      </IconButton>

      <Menu
        id="appMenu"
        keepMounted
        anchorEl={appsMenuAnchorEl}
        onClose={handleAppsMenuClose}
        open={Boolean(appsMenuAnchorEl)}
        className={styles.appMenu}
      >
        <MenuItem onClick={() => { window.open('/portal', '_portal'); handleAppsMenuClose(); }}>
          {portalTitle}
        </MenuItem>

        {attendantEnabled && (
          <MenuItem onClick={() => { window.open('/portal/attendant', '_attendant'); handleAppsMenuClose(); }}>
            {attendantTitle}
          </MenuItem>
        )}
        {webPhoneEnabled && (
          <MenuItem onClick={() => { window.open('/webphone', '_webphone'); handleAppsMenuClose(); }}>
            {webPhoneTitle}
          </MenuItem>
        )}
        {videoEnabled
          && (
          <MenuItem onClick={() => { window.open(videoPath, '_video'); handleAppsMenuClose(); }}>
            {videoTitle}
          </MenuItem>
          )}
        {analyticsEnabled
          && (
            <MenuItem onClick={() => { window.open('/analytics', '_analytics'); handleAppsMenuClose(); }}>
              {analyticsTitle}
            </MenuItem>
          )}
      </Menu>
    </>
  );
}

export default AppMenu;
